<template>
  <div id="UserInfo">
    <!--Title-->
    <div class="row">
      <h4 class="col-xs-12 card-title csp-card-title">Contact Information</h4>
    </div>
    <!--Text-->
    <div class="row">
      <div class="col-xs-12 ">
        <p class="card-text csp-banner-text">Go ahead and make any change you need!</p>
      </div>                
    </div>
    
    <div class="row">
      <div class="col-xs-12">
        <form>
          
          <div class="md-form">
            <input class="form-control" required type="text" id="csp_fname" name="fname" autocomplete="given-name" v-model="givenName">
            <label for="csp_fname" v-bind:class="{ active: givenName }">First Name</label>
          </div>
          
          <div class="md-form">
            <input class="form-control" required type="text" id="csp_lname" name="lname" autocomplete="family-name" v-model="surName">
            <label for="csp_lname" v-bind:class="{ active: surName }">Last Name</label>
          </div>
          
          <div class="md-form">
            <input class="form-control" required type="email" id="csp_email" name="email" autocomplete="email" v-model="emailAddress">
            <label for="csp_email" v-bind:class="{ active: emailAddress }">Email Address</label>
          </div>
          
          <div class="md-form">
            <input class="form-control" required type="tel" id="csp_tel_home" name="tel" autocomplete="tel" :value="homePhoneNumber" @maskinput="updateHomePhoneNumber" v-mask="{mask: phoneNumberMask, jitMasking: true, placeholder: ' ', returnUnmasked: true}">
            <label for="csp_tel_home" v-bind:class="{ active: homePhoneNumber }">Phone Number (Home)</label>
          </div>
          
          <div class="md-form">
            <input class="form-control" type="tel" id="csp_tel_mobile" name="tel" autocomplete="tel" :value="mobilePhoneNumber" @maskinput="updateMobilePhoneNumber" v-mask="{mask: phoneNumberMask, jitMasking: true, placeholder: ' ', returnUnmasked: true}">
            <label for="csp_tel_mobile" v-bind:class="{ active: mobilePhoneNumber }">Phone Number (Mobile)</label>
          </div>
          
          <div class="md-form">
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import mask from '../directives/MaskedInput'

  export default {
    name: 'UserInfo',
    directives: {
      mask
    },
    methods: {
      updateMobilePhoneNumber: function (value) {
        this.mobilePhoneNumber = value
      },
      updateHomePhoneNumber: function (value) {
        this.homePhoneNumber = value
      },
      updateEmailAddress: function (value) {
        this.emailAddress = value
      }
    },
    computed: {
      phoneNumberMask: function () {
        return this.$store.getters.phoneNumberMask
      },
      givenName: {
        get: function () {
          return this.$store.getters.givenName
        },
        set: function (newValue) {
          this.$store.commit('updateGivenName', newValue)
        }
      },
      surName: {
        get: function () {
          return this.$store.getters.surName
        },
        set: function (newValue) {
          this.$store.commit('updateSurName', newValue)
        }
      },
      emailAddress: {
        get: function () {
          return this.$store.getters.emailAddress
        },
        set: function (newValue) {
          this.$store.commit('updateEmailAddress', newValue)
        }
      },
      homePhoneNumber: {
        get: function () {
          return this.$store.getters.homePhoneNumber
        },
        set: function (newValue) {
          this.$store.commit('updatePhoneNumberHome', newValue)
        }
      },
      mobilePhoneNumber: {
        get: function () {
          return this.$store.getters.mobilePhoneNumber
        },
        set: function (newValue) {
          this.$store.commit('updatePhoneNumberMobile', newValue)
        }
      },
      ...mapGetters([
        'givenNameValid',
        'surNameValid',
        'emailAddressValid',
        'mobilePhoneNumberValid',
        'homePhoneNumberValid',
        'phoneNumberValid',
        'userInputValid'
      ])
    }
  }
</script>

<style scoped>

  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// UserInfo.vue?521f75af